import React, { Component } from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import DocumentsForYou from './components/DocumentsForYou';
import TermsAndConditions from './components/TermsAndConditions';
import AcceptTermsAndConditions from './components/AcceptTermsAndConditions';
import Submit from '../../components/Submit';
import { getHyperlink } from '../../utils';
import { INFO_FLAG } from '../../utils/constants';
import SecurityChecksSection from '../securityChecksSection';

class ImportantInformationPage extends Component {
  constructor(props) {
    super(props);
    this.submitEvidenceCall = this.submitEvidenceCall.bind(this);
    this.state = {
      showLoadingScreen: false,
      isFormSubmit: false
    };
  }

  submitEvidenceCall(data) {
    const { isTermsChecked, submitEvidenceCall } = this.props;
    this.setState({ isFormSubmit: true });
    isTermsChecked &&
      submitEvidenceCall(
        data,
        this.props.getSubtype,
        INFO_FLAG,
        this.props.isPrimaryApplicantEditFlow
      );
  }

  render() {
    const {
      bankId,
      getBusinessData,
      termsConditionsRef,
      tariffGuideRef,
      fscsRef,
      getProductType,
      showLoader,
      history,
      showLoadingScreen,
      isPrimaryApplicantEditFlow,
      onConfirmationCheckboxChange,
      isTermsChecked,
      onlineTarrifRef,
      digitalServicesTermsRef
    } = this.props;
    return (
      <Form
        onSubmit={this.submitEvidenceCall}
        initialValues={getBusinessData}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            {showLoadingScreen && !isPrimaryApplicantEditFlow ? (
              <SecurityChecksSection showLoader={showLoader} history={history} />
            ) : (
              <StandardBody>
                <Content>
                  {({
                    importantInformationPageTitle = '',
                    keyFeaturesPre,
                    keyFeatureAccount,
                    keyFeatureChoiceAccount,
                    businessCurrentAccountCBHyperlink,
                    businessCurrentAccountYBHyperlink,
                    businessChoiceAccountCBHyperlink,
                    businessChoiceAccountYBHyperlink,
                    sectionInformation,
                    subjectToQualify,
                    creditInterest,
                    plannedBorrow,
                    unplannedBorrow,
                    tariffGuide,
                    tariffGuideCBHyperlink,
                    tariffGuideYBHyperlink,
                    returnedItemFee,
                    eligibleDeposits,
                    FSCSWebsite,
                    FSCSWebsiteHyperlink,
                    viewOther,
                    FSCSLeaflet,
                    FSCSLeafletCBHyperlink,
                    FSCSLeafletYBHyperlink,
                    cancelAgreement,
                    standardBusinessTariff,
                    creditIntrestLinked,
                    submitYourApplicationHeading = '',
                    altBusinessAccountSubHeading5ContentA = '',
                    altBusinessAccountSubHeading5ContentB = '',
                    digitalBankingServiceKeyFeatures = '',
                    digitalBankingPara1 = '',
                    digitalBankingPara2 = '',
                    digitalBankingPara3 = '',
                    multipleUserAccess = '',
                    fasterPaymentText = '',
                    abilityToText = '',
                    sameDayPayment = '',
                    moveMoney = '',
                    cancelDD = '',
                    amendText = '',
                    payBills = '',
                    viewTransactionHistory = '',
                    viewDownloadStatement = '',
                    authorisePayment = '',
                    cashFlow = '',
                    helpDeskText = '',
                    pleaseNoteText = '',
                    chapsText = '',
                    businessInternetText = '',
                    serviceUnavailableText = '',
                    someFeaturesText = '',
                    minimumDeviceText = '',
                    fullDetailsText = ''
                  }) => (
                    <div>
                      <PageHeading>{submitYourApplicationHeading}</PageHeading>
                      <p>{altBusinessAccountSubHeading5ContentA}</p>
                      <p>{altBusinessAccountSubHeading5ContentB}</p>
                      <SectionHeading>{importantInformationPageTitle}</SectionHeading>
                      <SectionHeading>
                        {getProductType &&
                        getProductType.toLowerCase() === keyFeatureChoiceAccount.toLowerCase() ? (
                          <div>
                            {keyFeaturesPre}
                            <WebsiteLink
                              linkText={keyFeatureChoiceAccount}
                              url={getHyperlink(
                                businessChoiceAccountCBHyperlink,
                                businessChoiceAccountYBHyperlink,
                                bankId
                              )}
                              willOpenNewWindow
                            />
                          </div>
                        ) : (
                          <div>
                            {keyFeaturesPre}
                            <WebsiteLink
                              linkText={keyFeatureAccount}
                              url={getHyperlink(
                                businessCurrentAccountCBHyperlink,
                                businessCurrentAccountYBHyperlink,
                                bankId
                              )}
                              willOpenNewWindow
                            />
                          </div>
                        )}
                      </SectionHeading>
                      <p>{sectionInformation}</p>
                      <BulletList
                        items={[
                          getProductType === keyFeatureChoiceAccount
                            ? standardBusinessTariff
                            : subjectToQualify,
                          getProductType.toLowerCase() === keyFeatureChoiceAccount.toLowerCase()
                            ? creditIntrestLinked
                            : creditInterest,
                          plannedBorrow,
                          <span>
                            {unplannedBorrow}
                            <WebsiteLink
                              linkText={tariffGuide}
                              url={getHyperlink(
                                tariffGuideCBHyperlink,
                                tariffGuideYBHyperlink,
                                bankId
                              )}
                              willOpenNewWindow
                            />
                          </span>,
                          returnedItemFee,
                          <span>
                            {eligibleDeposits}
                            <WebsiteLink
                              linkText={FSCSWebsite}
                              url={FSCSWebsiteHyperlink}
                              willOpenNewWindow
                            />
                            {viewOther}
                            <WebsiteLink
                              linkText={FSCSLeaflet}
                              url={getHyperlink(
                                FSCSLeafletCBHyperlink,
                                FSCSLeafletYBHyperlink,
                                bankId
                              )}
                              willOpenNewWindow
                            />
                          </span>,
                          cancelAgreement
                        ]}
                      />
                      <SectionHeading>{digitalBankingServiceKeyFeatures}</SectionHeading>
                      <p>{digitalBankingPara1}</p>
                      <p>
                        <b>{digitalBankingPara2}</b>
                      </p>
                      <p>{digitalBankingPara3}</p>
                      <BulletList
                        items={[
                          multipleUserAccess,
                          fasterPaymentText,
                          abilityToText,
                          [
                            sameDayPayment,
                            moveMoney,
                            cancelDD,
                            amendText,
                            payBills,
                            viewTransactionHistory,
                            viewDownloadStatement,
                            authorisePayment,
                            cashFlow
                          ],
                          helpDeskText
                        ]}
                      />
                      <p>{pleaseNoteText}</p>
                      <BulletList
                        items={[
                          chapsText,
                          businessInternetText,
                          serviceUnavailableText,
                          someFeaturesText,
                          minimumDeviceText
                        ]}
                      />
                      <p>{fullDetailsText}</p>
                      <DocumentsForYou
                        bankId={bankId}
                        offer={getProductType}
                        termsConditionsRef={termsConditionsRef}
                        tariffGuideRef={tariffGuideRef}
                        fscsRef={fscsRef}
                        onlineTarrifRef={onlineTarrifRef}
                        digitalServicesTermsRef={digitalServicesTermsRef}
                      />

                      <TermsAndConditions />

                      <AcceptTermsAndConditions
                        isTermsChecked={isTermsChecked}
                        onConfirmationCheckboxChange={onConfirmationCheckboxChange}
                        isFormSubmit={this.state.isFormSubmit}
                      />
                    </div>
                  )}
                </Content>
                <Submit hideExit disabled={!isTermsChecked} />
              </StandardBody>
            )}
          </form>
        )}
      />
    );
  }
}

ImportantInformationPage.propTypes = {
  bankId: PropTypes.bankId.isRequired
};

export default ImportantInformationPage;
